import request from '../utils/request'

// 获取 语言包
export function languageGet(data) {
    return request({
        url: "/lang/package/get",
        method: "post",
        data
    })
}